import { Component } from '@angular/core';

@Component({
  templateUrl: 'footer.component.html',
  selector: 'wfp-footer',
  styleUrls: ['footer.component.scss'],
  standalone: false
})
export class FooterComponent {}
